import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-item"},[_c('GuaranteedTableFilters',{attrs:{"disabled":_vm.loading},on:{"guaranteed-filters-changed":_vm.guaranteedFiltersChanged}}),_c(VRow,[_c(VCol,[_c(VDataTable,{staticClass:"custom-elevation rounded-xl",attrs:{"headers":_vm.returnHeaders,"items":_vm.returnItems},scopedSlots:_vm._u([{key:"item.status",fn:function(ref){
var item = ref.item;
return [(item.bookingsInWeek > item.bookings.length)?_c('div',[_c(VIcon,[_vm._v("mdi-alert")])],1):_vm._e()]}},{key:"item.prefClientId",fn:function(ref){
var item = ref.item;
return [_c('ClientDetailsListItem',{attrs:{"location-id":item.prefLocationId,"group-id":item.prefGroupId,"client-id":item.prefClientId}})]}},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('BaseLink',{attrs:{"href":_vm.returnCandidateUrl(item.candidateID),"color":"primary","title":_vm.$t('general.link.viewCandidateTooltip'),"allow-insecure":""}},[_vm._v(_vm._s(item.name))])]}},{key:"item.dateFrom",fn:function(ref){
var item = ref.item;
return [_c('DateComponent',{attrs:{"date":item.dateFrom}})]}},{key:"item.dateUntil",fn:function(ref){
var item = ref.item;
return [_c('DateComponent',{attrs:{"date":item.dateUntil}})]}},{key:"item.owner",fn:function(ref){
var item = ref.item;
return [_c('ConsultantDetails',{attrs:{"id":item.ownerID}})]}},{key:"item.todaysBookingID",fn:function(ref){
var item = ref.item;
return [_c('PlacementTodays',{attrs:{"date":_vm.filter.date,"bookings":item.bookings}})]}},{key:"item.bookingsInWeek",fn:function(ref){
var item = ref.item;
return [_c('PlacementPeriod',{attrs:{"bookings":item.bookings}})]}},{key:"item.availability",fn:function(ref){
var item = ref.item;
return [_c('CandidateAvailabilityChart',{attrs:{"data":item.availability}})]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }